import { cva } from 'noddi-ui-common';

/**
 * The tinted canvas a backoffice page sits on. Pair with `data-page-variant` on the same element:
 * `bg-page-background` only follows that attribute because the color tokens are declared
 * `@theme inline` (index.css). A plain @theme would resolve the var() once on :root and every
 * variant would paint the default canvas.
 */
export const pageCanvasVariants = cva('flex-1 bg-page-background [--ambient-surface:var(--page-background)]', {
  variants: {
    fillHeight: {
      true: 'flex min-h-0 flex-col'
    }
  }
});

/**
 * Width and side gutters shared by a page's header and body, so their edges line up. No variant
 * overrides a base class: raw cva output keeps both, and stylesheet order, not the variant, would win
 * wherever the result skips `cn()` — a full-width body under a header still capped at 3xl.
 */
export const pageGutterVariants = cva('mx-auto px-4 md:px-5 xl:px-6', {
  variants: {
    fullWidth: {
      false: 'max-w-screen-3xl',
      true: ''
    },
    fillHeight: {
      true: 'flex min-h-0 w-full flex-1 flex-col'
    }
  },
  defaultVariants: { fullWidth: false }
});

/** Dims and blurs the page under a blocking prompt; stays pinned to the viewport and never covers the sidebar. */
export const pageBlockerVariants = cva(
  'sticky top-0 z-docked mb-[-100vh] flex h-screen items-center justify-center bg-background/80 px-4 backdrop-blur-xs'
);
